import React from 'react'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'

import Relazsizes from 'relazsizes'

import config from 'config'
import pintariaWhyData from './pintariaWhy.json'

const { assets_url: assetsUrl } = config
const pintariaAssetsPath = `${assetsUrl}/assets/img/pintaria/why`

const PintariaWhy = () => (
  <div className="pintaria-why">
    <SectionContainer paddingTop={80} paddingBottom={80} backgroundColor="#f6f7fa">
      <Container>
        <Typography component="h3" variant="title" className="text-variant-title-sm text-center">
          Kenapa Pintaria?
        </Typography>
        <div className="pintaria-why__row">
          {
            pintariaWhyData.map(item => (
              <div className="pintaria-why__box">
                <Relazsizes src={`${pintariaAssetsPath}/${item.imageUrl}.jpg`} className="pintaria-why__img" />
                <div className="pintaria-why__title-wrapper">
                  <Typography component="h6" variant="headline" className="text-center pintaria-why__title">
                    {item.title}
                  </Typography>
                </div>
                <Typography component="p" variant="subbody" className="text-center pintaria-why__description">
                  {item.description}
                </Typography>
              </div>
            ))
          }
        </div>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .pintaria-why {
          &__box {
            border-radius: 8px;
            box-shadow: 0 6px 16px 0 rgba(107, 143, 188, 0.1);
            background-color: #ffffff;
            padding: 25px 30px;
          }
          &__title-wrapper {
            margin: 20px 0 25px 0 !important;
          }
          :global(&__description) {
            color: #0c2846 !important;
            line-height: 1.71;
          }
          :global(&__img) {
            width: 100%;
          }
          @media screen and (max-width: 767px) {
            &__box:not(:last-child) {
              margin-bottom: 20px;
            }
          }
          @media screen and (min-width: 768px) {
            &__row {
              display: flex;
              align-items: stretch;
            }
            &__box {
              flex: 1 1 50%;
              display: flex;
              flex-direction: column;

              &:not(:last-child) {
                margin-right: 20px;
              }
            }
            &__title-wrapper {
              display: flex;
              align-items: center;
              flex-basis: 13%;
            }
          }
        }
      `}
    </style>
  </div>
)

export default PintariaWhy
